import React from 'react';
import './Timeline.css';
import NavbarAll from '../Navbar/NavbarAll';

const timelineData = [
  {
    year: "2019",
    events: [
      "Khadija-tul-Kubra Academy was formally established.",
      "2 Quranic schools / Makatib were established in Achrothar area of Thar.",
      "A Masjid was constructed in Achrothar area of Thar.",
      "A Solar water Project and a Hand pump were installed under the water supply project.",
      "Department for protection of sacred / holy papers was established.",
      "Food and basic necessities were provided to more than 500 families.",
      "Iftar & dinner was arranged for 300 fasting-people in Ramadan.",
      "Clothes and shoes were distributed among 3,000 needy people.",
      "Qurbani were made and meat distributed among 1000 needy people."
    ]
  },
  {
    year: "2020",
    events: [
      "19 more Quranic schools / Makatib established in Thar.",
      "Primary Level School established in Mirpur Khas, Sindh.",
      "2 mosques constructed in Korwah Badin and Mehandro Par Thar.",
      "Summer camp held at Khadija-tul-Kubra Academy.",
      "18 water projects including 11 solar were installed.",
      "Medical clinic built in Achhro-thar Desert.",
      "Free medical facilities provided in Karachi.",
      "Self-sufficiency: 1 rickshaw, 2 sewing machines, 20 stalls provided.",
      "Covid-19 relief: 5,000 ration packages, 40 teacher stipends, daily iftar.",
      "Eid relief packages to 1,000 families.",
      "Meat distributed to 3,000 people via Qurbani.",
      "Relief for rain-affected in Karachi, Sindh & Balochistan.",
      "Tents and medical camps for flood victims in Umer-kot, Nokot, Mirpur-Khas.",
      "Support in marriages of 20 girls.",
      "Winter packages to around 5,000 people."
    ]
  },
  {
    year: "2021",
    events: [
      "2 Quranic schools established in Sakran and Tico Baran, Balochistan.",
      "Summer camp held at Khadija-tul-Kubra Academy.",
      "Braille system workshop for blind education.",
      "50 water projects installed (25 solar) in Tharparker.",
      "Thousands received food packages.",
      "600 daily Iftar parcels during Ramadan.",
      "1500 Ramadan ration packages.",
      "Eid relief for 5000 people.",
      "Eid shopping for orphanage children.",
      "Qurbani-fe-Sabilillah meat for 55,000 families.",
      "Ijtemai Qurbani benefited hundreds.",
      "Thousands treated at medical camps.",
      "Winter support provided.",
      "9 people employed.",
      "Support in 16 marriages with dowry.",
      "Earthquake aid in Balochistan.",
      "Relief for 45 families in Palestine.",
      "Plantation drives in Karachi, Sindh & Balochistan."
    ]
  },
  {
    year: "2022",
    events: [
      "Braille Center inaugurated in Thar.",
      "40-day summer camp organized.",
      "Modern education equipment provided.",
      "Monthly scholarships initiated.",
      "20 Quranic schools established across country.",
      "3-day refresher teacher training.",
      "Independence Day celebrated in Quranic schools.",
      "2 mosques completed in Khorwa and Talhar.",
      "6 free medical camps held in Sindh.",
      "Wheelchairs distributed.",
      "Ambulance service started in DHA Karachi.",
      "96 hand pumps and 30 solar projects installed.",
      "Food for 74,500 people.",
      "Clothing for 14,000 people.",
      "20 sacred document collection units set up.",
      "HIMAYA project for orphans and widows started.",
      "Construction of Dar-e-Khadija Orphanage started.",
      "15 people employed.",
      "Support for 36 marriages."
    ]
  },
  {
    year: "2023",
    events: [
      "40-day summer camp for boys & girls.",
      "2 Quranic schools established.",
      "15-day teacher training workshop held.",
      "Masjid constructed at Thana Bola Khan.",
      "Medical camps at Thar and Karachi Ijtima.",
      "50 water projects installed, 16 pounds created.",
      "150 water tankers and 5,000 bottles distributed.",
      "25 families receiving monthly rations.",
      "1000 Ramadan ration packages.",
      "Daily iftar drives held.",
      "Eid-ul-Fitr relief to 500 families.",
      "Qurbani meat distributed across country via 30 centers.",
      "Winter clothing provided.",
      "Relief camps for flood victims in multiple provinces.",
      "Wheat seeds and cash for 30 poor farmers.",
      "21 houses built for flood victims.",
      "Massive flood aid including tents, rations, medical.",
      "Earthquake relief in Turkey.",
      "Rickshaw given to unemployed.",
      "9 marriage supports provided."
    ]
  },
  {
    year: "2024",
    events: [
      "Tazkeer-bil-Qur’an program started for women.",
      "Islamic summer camp conducted.",
      "Books & stipends to religious students.",
      "Teacher training on Elements of Learning.",
      "Seminars on Masjid-e-Aqsa & Seerat-un-Nabi.",
      "Solar energy installed at Dar-e-Khadija.",
      "Medical aid to 480+ patients.",
      "Eid shopping for 80 orphans via HIMAYA.",
      "Monthly support for orphans & widows.",
      "Monthly ration for 300 families.",
      "4000 Ramadan ration packages.",
      "Thousands of daily iftar parcels.",
      "Eid packages for thousands in Karachi & Sindh.",
      "30 Qurbani centers established.",
      "26 underprivileged girls supported in marriage.",
      "Independence Day celebrated in schools.",
      "Mosques built in Abdullah Kambhar & Viryam Solangi.",
      "10-day relief camp in Kharan, Balochistan.",
      "Aid to flood victims in Gwadar.",
      "Earthquake aid delivered in Morocco.",
      "Flood aid delivered in Libya.",
      "Daily iftar for 500 families in Gaza.",
      "Iftar dasterkhwan at Masjid-e-Aqsa.",
      "Aid to homeless families in Gaza.",
      "Qurbani for Gaza arranged & delivered from Karachi.",
      "Plantation drives in Karachi & Sindh.",
      "KWT awarded PCP gold certification.",
      "KWT certified by Sindh Charity Commission.",
      "KWT received Certificate of Excellence at CSR Summit."
    ]
  }
];

const Timeline = () => {
  return (
    <>
    <NavbarAll/>
    <div className="timeline-container">
      <h1 className="timeline-title">KWT Activities Timeline</h1>
      <div className="timeline">
        {timelineData.map((entry, index) => (
          <div className="timeline-item" key={index}>
            <div className="timeline-year">{entry.year}</div>
            <div className="timeline-content">
              <ul>
                {entry.events.map((event, idx) => (
                  <li key={idx}>{event}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>

  );
};

export default Timeline;
